export default ({...props}) => {
  const {size} = props.theme
  return `
      &[ap_position="app_bar"] {
        & img {
          height: ${size(3.125)}px;
        }
      }

      &[ap_position="app_content_area"] {
        & img {
          height: ${size(6.25)}px;
        }
      }
    `
}
